import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import AppBodyComponent from '../Components/AppBodyComponent'

function DonationCancel() {
    const navigate = useNavigate()

    return (
        <AppBodyComponent>
            <div className='flex flex-column gap-3 align-items-center p-4'>
                <div className='text-2xl font-bold'>Donation canceled</div>
                <div className='text-center'>
                    {'The payment was not completed. You can try again any time.'}
                </div>
                <div className='flex gap-2'>
                    <Button label='Back to places' onClick={()=>navigate('/app/user_home_places')} />
                    <Button label='Find places' severity='secondary' onClick={()=>navigate('/app/place_list')} />
                </div>
            </div>
        </AppBodyComponent>
    )
}

export default DonationCancel
